// import { combineReducers } from "@reduxjs/toolkit";
import loginSlice from "./login/loginSlice";
import sellerSlice from "./seller/sellerSlice";
import vendorSlice from "./seller/getVendorSlice";
import RoomBookingSlice from "./seller/getRoomSlice";
import settingColorSlice from "./seller/settingColorSlice";
import appointmentReducer from "./appointmentSlice/appointmentSlice";
const reducer = {
  loginReducer: loginSlice,
  sellerReducer: sellerSlice,
  getVendorReducer: vendorSlice,
  getRoomBookingReducer: RoomBookingSlice,
  getSettingColor: settingColorSlice,
  appointments: appointmentReducer,
 

};

export default reducer;
